import { ChponkView } from './chponk-view'
import { InViewPortMixin } from 'es6/mixins/in-viewport-mixin'
import $ from 'init/jquery'
import extend from 'lodash/extend'
import merge from 'lodash/merge'
import { okoPush } from 'helpers/oko-helpers'
import { Defaults } from 'es-decorators'
/**
 * Класс для слайда баннеров
 */
@Defaults({
  bannerData: '',
  chponckSelector: '.chponck-item',
  additionalOptions: ['mainWindow', 'eventBus', 'chponckSelector'],
})
export class ChponkPackView extends ChponkView {
  /**
   * @inheritDoc
   */
  beforeRun () {
    this.chponcks = this.$(this.chponckSelector)
    super.beforeRun()
  }

  /**
   * Установка данных слайда баннеров как данные баннера
   *
   * @private
   */
  _setBannerData () {
    this.bannerData = this._createKey(this.chponcks)
  }

  /**
   * @inheritDoc
   */
  _setCarouserListener () {
    const parent = this.$el.parent(),
      isOwlChponk = parent.hasClass('owl-item'),
      isCssChponk = parent.hasClass('carousel-item')
    if (isOwlChponk || isCssChponk) {
      this.visibilityFlag = (isOwlChponk && parent.hasClass('active'))
        || (isCssChponk && parent.css('opacity') === 1)
      this.listenTo(this.eventBus, 'carousel.changed.item', this.changeCarouselBanner)
    }
  }

  /**
   * @inheritDoc
   */
  _createKey ($elements) {
    let result = []
    $elements.each((index, item) => {
      result.push(this.getBannerDataAttributes(this.$(item)).id)
    })
    if (result.length === 0) {
      result.push('empty')
    }
    return result.join('_')
  }

  /**
   * @inheritDoc
   */
  changeCarouselBanner (e) {
    const $pack = $($(e).children()[0])
    const chponkData = this._createKey($pack.find(this.chponckSelector))
    if (chponkData !== this.bannerData) {
      return
    }
    this.visibilityFlag = true
    this.showListening(window)
    this.changeViewport(this.viewPortModel)
  }

  /**
   * @inheritDoc
   */
  inViewPort () {
    // если элемент не виден то ничего не отправляем
    if (!this.isVisible()) {
      return
    }
    if (this.sent.indexOf(this.bannerData) === -1) {
      // Отписываемся от событий перед отправкой в око
      this.stopAllListening()
      this.chponcks.each((index, item) => {
        okoPush(merge({
          n: 'banner',
        }, this.getBannerDataAttributes($(item))))
      })
      this.sent.push(this.bannerData)
    }
  }

  /**
   * Возвращает массив с ошибками в data-атрибутах баннера
   *
   * @returns {Array} errors
   */
  getBannerDataAttributesError () {
    let errors = []
    this.chponcks.length === 0 && errors.push('Отсутствуют баннера в блоке')
    this.chponcks.each((index, item) => {
      let data = this.getBannerDataAttributes(this.$(item))
      if (!data['id']) {
        errors.push('Не указан ID баннера')
      }
      if (!data['num']) {
        errors.push('Не указан номер баннера')
      }
      if (!data['url'].length) {
        errors.push('Не указан URL баннера')
      }
      if (!data['place_id']) {
        errors.push('Не указана позиция баннера')
      }
    })
    return errors
  }
}
// подключаем слежение за попаданием во viewport при скролле (для ОКО)
extend(ChponkPackView.prototype, InViewPortMixin)
